var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClipboardBlueCircle = function SvgClipboardBlueCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#E6F4FF",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M23.333 13.333c.775 0 1.162 0 1.48.085a2.5 2.5 0 0 1 1.768 1.768c.085.318.085.706.085 1.48v7.667c0 1.4 0 2.1-.272 2.635a2.5 2.5 0 0 1-1.093 1.093c-.535.272-1.235.272-2.635.272h-5.333c-1.4 0-2.1 0-2.635-.272a2.5 2.5 0 0 1-1.093-1.093c-.272-.534-.272-1.235-.272-2.635v-7.666c0-.775 0-1.163.085-1.48a2.5 2.5 0 0 1 1.768-1.768c.318-.086.705-.086 1.48-.086M18 15h4c.467 0 .7 0 .879-.09a.833.833 0 0 0 .364-.365c.09-.178.09-.412.09-.878V13c0-.467 0-.7-.09-.878a.833.833 0 0 0-.364-.364c-.178-.091-.412-.091-.879-.091h-4c-.466 0-.7 0-.878.09a.833.833 0 0 0-.364.365c-.09.178-.09.411-.09.878v.667c0 .466 0 .7.09.878.08.157.207.284.364.364.178.091.412.091.878.091Z"
  })));
};
export default SvgClipboardBlueCircle;